var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-drawer',{attrs:{"title":"Detalle de CxC del empleado","visible":_vm.cxcDetailIsVisible,"append-to-body":true,"size":"60%"},on:{"update:visible":function($event){_vm.cxcDetailIsVisible=$event},"close":_vm.closingCXCdetailDrawer}},[_c('rabbey-table-3',{attrs:{"data":_vm.detailData,"columns":_vm.detailColumns}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }